module.exports = {
	'SearchPage': require('./search-page'),
	'ProductSearchPage': require('./product-search-page'),
	'RequestAccount': require('./request-account'),
	'NewsLanding': require('./news-landing')
};
